import React, { useState } from 'react';
import styles from '../ReportCard.module.scss';
import moment from 'moment';
import Pagination from './Pagination';
import SearchBar from './SearchBar';
import MiniMap from '../MiniMap';

const CompletedLoadsTableView = ({
  completedLoads,
  completedCount,
  completedNext,
  completedPrev,
  completedPage,
  setCompletedPage,
  completedSearch,
  setCompletedSearch,
  user,
}) => {
  const [visibleMaps, setVisibleMaps] = useState({});
  const toggleMap = (id, geoType) => {
    const key = `${id}-${geoType}`;
    setVisibleMaps(prev => ({ ...prev, [key]: !prev[key] }));
  };
  const formatDateTime = (dateString) => {
    if (!dateString) return '-';
    // Сначала пробуем распарсить как DD.MM.YYYY HH:mm
    let date = moment(dateString, 'DD.MM.YYYY HH:mm', true);
    if (!date.isValid()) {
      // Если не получилось, пробуем ISO формат
      date = moment(dateString);
      if (date.isValid()) {
        return date.format('DD.MM.YYYY HH:mm');
      }
      return dateString; // Вернем как есть, если не смогли распарсить
    }
    return dateString; // Уже в нужном формате
  };

  return (
    <div className={styles.table_info_wrapper}>
      <Pagination
        page={completedPage}
        setPage={setCompletedPage}
        count={completedCount}
        hasNext={!!completedNext}
        hasPrev={!!completedPrev}
        shownCount={completedLoads.length}
      />

      <SearchBar
        value={completedSearch}
        onChange={setCompletedSearch}
        onClear={() => setCompletedSearch('')}
        placeholder="Поиск по водителю, машине, базе..."
      />

      <div className={styles.cardGridView}>
        {completedLoads && completedLoads.length > 0 ? (
          completedLoads.map((load, idx) => {
            const driverName = load.employee_name || '-';
            const vehicleNumber = load.vehicle_number || '-';
            const baseName = load.top_base_name || load.chpp_name || load.private_point_name || '-';
            const rowNumber = (completedPage - 1) * 10 + idx + 1;
            
            const statusText = load.status === 'Въехал в точку Б' ? 'Доставил в Базу' : load.status || '-';

            return (
              <div key={load.id} className={styles.loadCard}>
                <div className={styles.loadCardHeader}>
                  <div className={styles.vehicleNumberBox}>
                    <div className={styles.vehicleNumber}>{vehicleNumber}</div>
                    <div className={styles.vehicleModel}>{load.vehicle_model || '-'}</div>
                  </div>
                  <div className={styles.statusBadgeCard} data-status={load.status === 'Въехал в точку Б' ? 'Въехал в точку Б' : load.status}>
                    {statusText}
                  </div>
                </div>

                <div className={styles.loadCardBody}>
                  {/* Driver */}
                  <div className={styles.infoBlock}>
                    <div className={styles.driverName}>
                      👤 {driverName}
                    </div>
                    <div className={styles.infoRow}>
                      <span className={styles.infoLabel}>Телефон:</span>
                      <span className={styles.infoValue}>{load.employee_phone || '-'}</span>
                    </div>
                    <div className={styles.infoRow} style={{ marginTop: '8px' }}>
                      <span className={styles.infoLabel}>База назначения:</span>
                      <span style={{ color: '#0d6efd', fontWeight: '700' }}>{baseName}</span>
                    </div>
                  </div>

                  {/* Entry A */}
                  <div className={styles.timeGeoBlock}>
                     <div style={{gridColumn: '1 / -1', marginBottom: '8px', fontWeight: 'bold', fontSize: '11px', color: '#6c757d', textTransform: 'uppercase'}}>Въезд (Кара-Кече)</div>
                     <div className={styles.timeGeoItem}>
                        <span className={styles.timeGeoLabel}>Время</span>
                        <span className={styles.timeGeoValue}>{formatDateTime(load.time_a)}</span>
                     </div>
                     <div className={styles.timeGeoItem} style={{ alignItems: 'flex-end' }}>
                       {load.geo_a && (
                         <div style={{ display: 'flex', gap: '8px' }}>
                            <button onClick={() => window.open(`https://www.google.com/maps?q=${load.geo_a}`, '_blank')} className={styles.geoLinkBtn}>📍</button>
                            <button onClick={() => toggleMap(load.id, 'geo_a')} className={styles.mapToggleBtn}>{visibleMaps[`${load.id}-geo_a`] ? '✕' : '🗺️'}</button>
                         </div>
                       )}
                     </div>
                     
                     {/* Mark Info Entry */}
                     <div className={styles.markedInfoBlock}>
                       <div className={styles.markedTitle}>Отметил въезд</div>
                       <div className={styles.markedName}>{load.guard_name || 'Не указан'}</div>
                       {load.guard_phone && (
                         <div className={styles.markedPhone}>
                           📞 {load.guard_phone}
                         </div>
                       )}
                     </div>

                     {load.geo_a && visibleMaps[`${load.id}-geo_a`] && (
                       <div style={{ gridColumn: '1 / -1', height: '150px', borderRadius: '8px', overflow: 'hidden', marginTop: '8px' }}>
                         <MiniMap geo={load.geo_a} />
                       </div>
                     )}
                  </div>

                  {/* Exit A */}
                  <div className={styles.timeGeoBlock}>
                     <div style={{gridColumn: '1 / -1', marginBottom: '8px', fontWeight: 'bold', fontSize: '11px', color: '#6c757d', textTransform: 'uppercase'}}>Выезд (Кара-Кече)</div>
                     <div className={styles.timeGeoItem}>
                        <span className={styles.timeGeoLabel}>Время</span>
                        <span className={styles.timeGeoValue}>{formatDateTime(load.time_a_exit)}</span>
                     </div>
                      <div className={styles.timeGeoItem} style={{ alignItems: 'flex-end' }}>
                       {load.geo_a_exit && (
                         <div style={{ display: 'flex', gap: '8px' }}>
                            <button onClick={() => window.open(`https://www.google.com/maps?q=${load.geo_a_exit}`, '_blank')} className={styles.geoLinkBtn}>📍</button>
                            <button onClick={() => toggleMap(load.id, 'geo_a_exit')} className={styles.mapToggleBtn}>{visibleMaps[`${load.id}-geo_a_exit`] ? '✕' : '🗺️'}</button>
                         </div>
                       )}
                     </div>

                     {/* Mark Info Exit */}
                     <div className={styles.markedInfoBlock}>
                       <div className={styles.markedTitle}>Отметил выезд</div>
                       <div className={styles.markedName}>{load.exit_guard_name || 'Не указан'}</div>
                       {load.exit_guard_phone && (
                         <div className={styles.markedPhone}>
                           📞 {load.exit_guard_phone}
                         </div>
                       )}
                     </div>

                     {load.geo_a_exit && visibleMaps[`${load.id}-geo_a_exit`] && (
                       <div style={{ gridColumn: '1 / -1', height: '150px', borderRadius: '8px', overflow: 'hidden', marginTop: '8px' }}>
                         <MiniMap geo={load.geo_a_exit} />
                       </div>
                     )}
                  </div>

                  {/* Arrival B */}
                   <div className={styles.timeGeoBlock} style={{borderBottom: 'none'}}>
                     <div style={{gridColumn: '1 / -1', marginBottom: '8px', fontWeight: 'bold', fontSize: '11px', color: '#6c757d', textTransform: 'uppercase'}}>Прибытие (База)</div>
                     <div className={styles.timeGeoItem}>
                        <span className={styles.timeGeoLabel}>Время</span>
                        <span className={styles.timeGeoValue}>{formatDateTime(load.time_b)}</span>
                     </div>
                      <div className={styles.timeGeoItem} style={{ alignItems: 'flex-end' }}>
                       {load.geo_b && (
                         <div style={{ display: 'flex', gap: '8px' }}>
                            <button onClick={() => window.open(`https://www.google.com/maps?q=${load.geo_b}`, '_blank')} className={styles.geoLinkBtn}>📍</button>
                            <button onClick={() => toggleMap(load.id, 'geo_b')} className={styles.mapToggleBtn}>{visibleMaps[`${load.id}-geo_b`] ? '✕' : '🗺️'}</button>
                         </div>
                       )}
                     </div>

                     {/* Mark Info Arrival */}
                     <div className={styles.markedInfoBlock}>
                       <div className={styles.markedTitle}>Принял (База)</div>
                       <div className={styles.markedName}>{load.by_guard_name || 'Не указан'}</div>
                       {load.by_guard_phone && (
                         <div className={styles.markedPhone}>
                           📞 {load.by_guard_phone}
                         </div>
                       )}
                     </div>

                     {load.geo_b && visibleMaps[`${load.id}-geo_b`] && (
                       <div style={{ gridColumn: '1 / -1', height: '150px', borderRadius: '8px', overflow: 'hidden', marginTop: '8px' }}>
                         <MiniMap geo={load.geo_b} />
                       </div>
                     )}
                  </div>
                  
                  {/* Durations */}
                  <div style={{ background: '#f0f2f5', padding: '12px', borderRadius: '12px', display: 'flex', flexDirection: 'column', gap: '8px'}}>
                     <div className={styles.infoRow}>
                        <span className={styles.infoLabel}>Время погрузки:</span>
                        <span className={styles.infoValue}>{load.duration_str_loading || '-'}</span>
                     </div>
                     <div className={styles.infoRow}>
                        <span className={styles.infoLabel}>Время доставки:</span>
                         <span className={styles.infoValue} style={{color: '#198754'}}>{load.duration_str || '-'}</span>
                     </div>
                      <div className={styles.infoRow}>
                        <span className={styles.infoLabel}>Общее время:</span>
                         <span className={styles.infoValue}>{load.total_duration_str || '-'}</span>
                     </div>
                  </div>

                  {/* Guards involved - REMOVED since moved up */}
                  
                  {/* Photo B */}
                   {(user?.is_admin_of || user?.is_report_of) && load.photo_b && (
                      <div style={{ marginTop: '10px', textAlign: 'center' }}>
                        <a href={load.photo_b} target="_blank" rel="noopener noreferrer">
                          <img
                            src={load.photo_b}
                            alt="Фото точки Б"
                            style={{ width: '100%', maxHeight: '200px', objectFit: 'cover', borderRadius: '8px', border: '2px solid #0d6efd' }}
                          />
                        </a>
                      </div>
                   )}

                </div>

                <div className={styles.loadCardFooter}>
                   <div className={styles.notes} title={load.notes || 'Нет примечаний'}>
                     📝 {load.notes || 'Нет примечаний'}
                   </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className={styles.noData} style={{gridColumn: '1 / -1'}}>Нет данных</div>
        )}
      </div>

      <Pagination
        page={completedPage}
        setPage={setCompletedPage}
        count={completedCount}
        hasNext={!!completedNext}
        hasPrev={!!completedPrev}
        shownCount={completedLoads.length}
        style={{ marginTop: '8px', marginBottom: 0 }}
      />
    </div>
  );
};

export default CompletedLoadsTableView;
